module.exports = __webpack_public_path__ + "static/3-d985dbe9f07812821defcad5c1adf86d.png";